import _ from 'lodash';
import { useEffect, useState } from 'react';
import StorageAbstractFactory from '@infrastructure/cache';

const storage = StorageAbstractFactory.getSyncGlobalInstance();

export default function useLocalStorageState(key, defaultValue) {
  const [state, _setState] = useState(defaultValue);

  useEffect(() => {
    const item = storage.getItem(key);
    if (item) _setState(item);
    else _setState(defaultValue);
  }, [defaultValue, key]);

  const setState = value => {
    _setState(pre => {
      let newState = value;
      if (_.isFunction(value)) newState = value(pre);
      storage.setItem(key, newState);
      return newState;
    });
  };

  const deleteState = () => {
    localStorage.removeItem(key);
  };

  return [state, setState, deleteState];
}
